<template>
  <main>
    <PageHeaderUI title="Ratings" breadcrumb="booking  >> Ratings" />
    <div class="bg-white p-4">
      <b class="block w-full mb-16 pt-8 font-semibold text-lg">Dispatcher Ratings</b>
      <div class="flex flex-wrap justify-center">
        <div class="img_wrapper">
          <img :src="driverImg" alt=""
            class="image_url" />
          <b class="block w-full text-center">{{driverName}}</b>
        </div>
        <div class="w-full flex justify-center flex-wrap">
          <p class="packg_uppdate">Awesome, your package has just been delivered! Rate your dispatcher.</p>
          <div class="w-full flex justify-center">
            <div class="pt-3 pb-3">
              <star-rate :canChange="true" :onChange="getRate" :size="35"></star-rate>
            </div>
          </div>

          <div class="flex justify-center">
            <div class="rate_item_wrapper">
              <button @click="starValue = item" :class="`rate_item ${item === starValue && 'active'}`"
                v-for="item in startContents" :key="item">{{ item
                }}</button>
            </div>
          </div>
        </div>
      </div>

      <div class="py-3 flex mt-6" v-if="starValue === 'others'">
        <div class="w-full">
          <label class="text-gray-400">Comments</label>
          <textarea class="w-full bg-gray-200 resize-none p-3 mt-0 h-48 rounded"
            placeholder="Start typing your comments here…" v-model="comment"></textarea>
        </div>
      </div>


      <div class="flex justify-between items-center py-3 mt-12">
        <button @click="$router.go(-1)">Cancel</button>
        <primary-button @click="submitRatings" class="shadow-md font-normal" buttonText="Submit" :loading="loading" />
      </div>
      <AcknowledgeRating :showModal="hasSubmit" @close-modal="hasSubmit = false" />
    </div>
  </main>
</template>

<script>
import PageHeaderUI from "@/components/Ondemand/UI/PageHeaderUI.vue";
import AcknowledgeRating from "@/components/Ondemand/Bookings/modals/AcknowledgeRating.vue";

export default {
  components: {
    PageHeaderUI,
    AcknowledgeRating
  },
  watch: {
    rate() {
      this.starValue = null
    }
  },
  data() {
    return {
      reason: "",
      isTip: false,
      hasSubmit: false,
      rate: null,
      option: '',
      comment: "",
      driver: {},
      showIssuesDropDown: true,
      loading: false,
      starValue: null,
      starContent: {
        star_2: [
          "Delivered late",
          "Package  Damaged",
          "Wrong package",
          "Safety concern",
          "Unprofessional",
          "Incomplete delivery",
          "others"
        ],
        star_3: [
          "Delivered late",
          "Package  Damaged",
          "Wrong package",
          "Safety concern",
          "Unprofessional",
          "Incomplete delivery",
          "others"
        ]
      },
    };
  },
  mounted() {
    this.driver = this.$store.getters?.getRatingsBooking?.driver
  },
  computed: {
    driverName(){
        return `${this.driver?.first_name || this.driver?.firstname} ${this.driver?.last_name || this.driver?.lastname}`
    },
    driverImg(){
        return  this.driver?.imageurl
    },
    startContents() {
      switch (this.rate) {
        case 2:
          return this.starContent.star_2;

        case 3:
          return this.starContent.star_3;

        default:
          return []
      }
    },
    payload() {
      return {
        ratedUserId: this.$route.query.driver,
        tags: this.starValue ? [this.starValue] : undefined,
        shippingId: this.$route.params.id,
        rating: this.rate,
        reason: this.option,
        comment: this.comment
      }
    }
  },
  methods: {
    getRate(val) {
      Number(val) == 5 ? (this.showIssuesDropDown = false) : (this.showIssuesDropDown = true);
      this.rate = val
    },
    async submitRatings() {
      this.loading = true;
      try {
        await this.$_submitRating(this.payload);
        this.hasSubmit = true
      } catch (error) {
        this.generateToast(error?.response?.data?.error)
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.rate_item_wrapper {
  @apply flex justify-center flex-wrap gap-3 max-w-[600px] mt-2;
}

.rate_item {
  @apply bg-gray-100 rounded-2xl px-3 py-1 text-sm;

  &.active {
    @apply bg-primary-yellow;
  }
}

.packg_uppdate {
  @apply w-full px-2 text-center max-w-[400px]
}

.tips {
  @apply inline-block rounded border border-gray-100 py-2 px-3 mr-2 cursor-pointer
}
.image_url{
  @apply  mb-2 rounded-full h-[120px] w-[120px] object-cover
}
.img_wrapper{
  @apply w-[120px] mr-4 flex justify-center flex-wrap mb-4
}
</style>
